import * as React from 'react'
function SvgOsAndroid(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M30 20v16H10V20h20zM6 20a2 2 0 012 2v10a2 2 0 01-4 0V22a2 2 0 012-2zm28 0a2 2 0 012 2v10a2 2 0 01-4 0V22a2 2 0 012-2zM27.168 5.446a1 1 0 111.664 1.108l-2.506 3.76C28.552 12.148 30 14.89 30 18H10c0-3.11 1.448-5.852 3.674-7.686l-2.506-3.76a1 1 0 111.664-1.108l2.506 3.758C16.736 8.46 18.306 8 20 8s3.264.46 4.662 1.204z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgOsAndroid
